import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import CenterOptionList from 'components/common/CommonComponent/CenterOptionList';
import { notification, Button, Descriptions, Input, Radio } from 'antd';

@inject('centerInfoStore')
@observer
class CenterDetail extends Component {
  state = {
    saveData: {
      ceCd: '',
      ceNm: '',
      ceUseYn: 'Y',
      ceType: process.env.REACT_APP_TYPE_CENTER,
      ceBranchCd: '',
      ceBranchNm: ''
    }
  };

  onChangValue = (dataVal, dataNm) => {
    if (dataNm === 'ceCd') {
      this.props.centerInfoStore.onChangValue('checkCeCd', false);
    }

    if (dataNm === 'ceType' && dataVal === process.env.REACT_APP_TYPE_BRANCH) {
      this.setState({
        saveData: {
          ...this.state.saveData,
          ceType: dataVal,
          ceBranchCd: '',
          ceBranchNm: ''
      }});
      return;
    }
    
    this.setState({
      saveData: {
        ...this.state.saveData,
        [dataNm]: dataVal
    }});
  };

  setData = (mode) => {
    this.props.centerInfoStore.onViewMode(mode);
    if (mode === 'detail' || mode === 'add') {
      this.setState({
        saveData: {
          ceCd: '',
          ceNm: '',
          ceUseYn: 'Y'
        }
      });
    } else if (mode === 'mod') {
      this.setState({
        saveData: {
          ...this.state.saveData,
          ...this.props.centerInfoStore.detailData
      }});
    }
  };

  onSave = () => {
    if (this.state.saveData.ceCd === '') {
      notification.warning({placement: 'bottomLeft', message: `코드를 입력하세요.`, duration: 2});
      return false;
    }

    if (this.state.saveData.ceType === process.env.REACT_APP_TYPE_CENTER && this.state.saveData.ceBranchCd === '') {
      notification.warning({placement: 'bottomLeft', message: `지사를 선택해주세요.`, duration: 2});
      return false;
    }
    
    if (this.state.saveData.ceNm === '') {
      notification.warning({placement: 'bottomLeft', message: `센터명를 입력해주세요.`, duration: 2});
      return false;
    }

    if (this.props.centerInfoStore.viewMode === 'add') {
      if (this.props.centerInfoStore.valCondition.checkCeCd === false) {
        notification.warning({placement: 'bottomLeft', message: `코드 중복체크를 해주세요.`, duration: 2});
        return false;
      }
      this.props.centerInfoStore.addCenterInfo(this.state.saveData);
    } else if (this.props.centerInfoStore.viewMode === 'mod') {
      this.props.centerInfoStore.modCenterInfo(this.state.saveData);
    }
  };

  render() {
    const { viewMode, valCondition, detailData, disCenterCheck } = this.props.centerInfoStore;
    const { saveData } = this.state;
    return (
      <Fragment>
        <div className="button-group">
          <h2>정보
            {viewMode === 'detail' && <Fragment> 상세보기</Fragment>}
            {viewMode === 'add' && <Fragment> 추가</Fragment>}
            {viewMode === 'mod' && <Fragment> 수정</Fragment>}
          </h2>
          <div className="button-right">
            {viewMode === 'detail'
            ? <ul>
                <li><Button type="primary" onClick={()=>this.setData('list')}>목록</Button></li>
                <li><Button type="primary" onClick={()=>this.setData('mod')}>수정</Button></li>
              </ul>
            : <ul>
                <li><Button type="primary" onClick={()=>this.onSave()}>저장</Button></li>
                <li><Button type="primary" onClick={()=>this.setData(viewMode === 'add' ? 'list' : 'detail')}>취소</Button></li>
              </ul>
            }
          </div>
        </div>

        <div className="table_th_W">
          <Descriptions bordered>
            <Descriptions.Item label="구분 *" span={1}>
              {viewMode === 'detail'
              ? ((detailData !== null && detailData.ceType !== undefined && detailData.ceType !== null) && 
                detailData.ceType === process.env.REACT_APP_TYPE_BRANCH 
                ? <Fragment>지사</Fragment> : <Fragment>센터</Fragment>)
              : <Radio.Group
                  onChange={(e)=>this.onChangValue(e.target.value, 'ceType')}
                  value={(saveData !== null && saveData.ceType !== undefined && saveData.ceType !== null) 
                    ? saveData.ceType : process.env.REACT_APP_TYPE_CENTER}
                >
                  <Radio value={process.env.REACT_APP_TYPE_BRANCH}>지사</Radio>
                  <Radio value={process.env.REACT_APP_TYPE_CENTER}>센터</Radio>
                </Radio.Group>
              }
            </Descriptions.Item>
            <Descriptions.Item label="사용유무 *" span={2}>
              {viewMode === 'detail'
              ? ((detailData !== null && detailData.ceUseYn !== undefined && detailData.ceUseYn !== null) && 
                detailData.ceUseYn === 'Y' ? <Fragment>사용</Fragment> : <Fragment>미사용</Fragment>)
              : <Radio.Group
                  onChange={(e)=>this.onChangValue(e.target.value, 'ceUseYn')}
                  value={(saveData !== null && saveData.ceUseYn !== undefined && saveData.ceUseYn !== null) ? saveData.ceUseYn : 'N'}
                >
                  <Radio value={"Y"}>사용</Radio>
                  <Radio value={"N"}>미사용</Radio>
                </Radio.Group>
              }
            </Descriptions.Item>
            {(viewMode === 'detail')
            ? (detailData !== null && detailData.ceType !== undefined && detailData.ceType !== null 
              && detailData.ceType === process.env.REACT_APP_TYPE_CENTER) &&
              <Fragment>
                <Descriptions.Item label="지사 *" span={3}>
                  <CenterOptionList
                    onlyBranchCd={true}
                    branchCdDisabled={true}
                    ceBranchCdValue={detailData.ceBranchCd}
                    eBranchCdChange={(value)=>{
                    }}
                  />
                </Descriptions.Item>
              </Fragment>
            : (saveData !== null && saveData.ceType !== undefined && saveData.ceType !== null 
              && saveData.ceType === process.env.REACT_APP_TYPE_CENTER) &&
              <Fragment>
                <Descriptions.Item label="지사 *" span={3}>
                  <CenterOptionList
                    onlyBranchCd={true}
                    branchCdDisabled={false}
                    ceBranchCdValue={saveData.ceBranchCd}
                    eBranchCdChange={(value)=>{
                      this.setState({
                        saveData: {
                          ...saveData,
                          ceBranchCd: value
                        }
                      });
                    }}
                  />
                </Descriptions.Item>
              </Fragment>
            }
            {(viewMode === 'detail')
            ? <Fragment>
                <Descriptions.Item label={
                  (detailData !== null && detailData.ceType !== undefined && detailData.ceType !== null 
                  && detailData.ceType === process.env.REACT_APP_TYPE_CENTER) ? "센터 *" : "지사 *"} span={1}>
                  {detailData !== null && detailData.ceNm !== undefined && detailData.ceNm !== null && detailData.ceNm}
                </Descriptions.Item>
                <Descriptions.Item label={
                  (detailData !== null && detailData.ceType !== undefined && detailData.ceType !== null 
                  && detailData.ceType === process.env.REACT_APP_TYPE_CENTER) ? "센터코드 *" : "지사코드 *"}  span={2}>
                  {detailData !== null && detailData.ceCd !== undefined && detailData.ceCd !== null && detailData.ceCd}
                </Descriptions.Item>
              </Fragment>
            : <Fragment>
                <Descriptions.Item label={
                  (saveData !== null && saveData.ceType !== undefined && saveData.ceType !== null 
                  && saveData.ceType === process.env.REACT_APP_TYPE_CENTER) ? "센터 *" : "지사 *"} span={1}>
                  <Input
                    value={saveData.ceNm}
                    onChange={(e)=>this.onChangValue(e.target.value, 'ceNm')}
                  />
                </Descriptions.Item>
                <Descriptions.Item label={
                  (saveData !== null && saveData.ceType !== undefined && saveData.ceType !== null 
                  && saveData.ceType === process.env.REACT_APP_TYPE_CENTER) ? "센터코드 *" : "지사코드 *"}  span={2}>
                  {(viewMode === 'mod')
                  ? (detailData !== null && detailData.ceCd !== undefined && detailData.ceCd !== null && detailData.ceCd)
                  : <Fragment>
                      <Input
                        style={{ width: '40%' }}
                        value={saveData.ceCd}
                        onChange={(e)=>this.onChangValue(e.target.value, 'ceCd')}
                      />
                      {valCondition.checkCeCd === false &&
                        <Button
                          type="primary"
                          onClick={()=>{
                            saveData.ceCd === '' 
                            ? notification.warning({placement: 'bottomLeft', message: `체크할 값을 입력하세요.`, duration: 2})
                            : disCenterCheck(saveData.ceCd);
                          }}
                        >중복체크</Button>
                      }
                    </Fragment>
                  }
                </Descriptions.Item>
              </Fragment>
            }
          </Descriptions>
        </div>
      </Fragment>
    );
    
  }
}

export default withRouter(CenterDetail);
